import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { ListChecks, Plus, Trash2, Zap } from "lucide-react";

const FASE_LABEL = { pubblicazione: "Pubblicazione", proposta: "Proposta", preliminare: "Preliminare", rogito: "Rogito" };

export default function ChecklistTappeConfigCard() {
  const [cfg, setCfg] = useState(null);
  const [auto, setAuto] = useState([]);
  const [fase, setFase] = useState("pubblicazione");
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/checklist-tappe").then((r) => { setCfg(r.data.fasi); setAuto(r.data.auto || []); }).catch(() => setCfg(null)); }, []);
  if (!cfg) return null;
  const voci = cfg[fase] || [];
  const setVoci = (v) => setCfg({ ...cfg, [fase]: v });
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/settings/checklist-tappe", cfg); setCfg(r.data.fasi); toast.success("Checklist salvate"); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <div className="card-immo p-5" data-testid="checklist-config-card">
      <div className="flex items-center gap-2 mb-1"><span className="w-8 h-8 rounded-xl bg-[#FC82ED]/15 text-[#FC82ED] flex items-center justify-center"><ListChecks size={16} /></span><h2 className="font-display font-bold text-base">Checklist di tappa</h2></div>
      <p className="text-xs text-[var(--muted)] mb-3">Voci che la Segreteria spunta nella pratica. <Zap size={11} className="inline text-[#9A6A00]" /> = si spunta da sola.</p>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {Object.keys(FASE_LABEL).map((f) => (
          <button key={f} data-testid={`cc-tab-${f}`} onClick={() => setFase(f)} className={`px-3 py-1.5 rounded-full text-xs font-semibold border ${fase === f ? "bg-[#111111] text-white border-[#111111]" : "border-[var(--border)]"}`}>{FASE_LABEL[f]}</button>
        ))}
      </div>
      <div className="space-y-2">
        {voci.map(([vid, label], i) => (
          <div key={`${vid}-${i}`} className="flex items-center gap-2">
            {auto.includes(vid) && <Zap size={14} className="text-[#9A6A00] shrink-0" />}
            <input data-testid={`cc-voce-${fase}-${i}`} value={label} onChange={(e) => setVoci(voci.map((v, j) => (j === i ? [v[0], e.target.value] : v)))}
              className="flex-1 min-w-0 px-3 py-2 rounded-lg border border-[var(--border)] text-base sm:text-sm" />
            <button data-testid={`cc-del-${fase}-${i}`} onClick={() => setVoci(voci.filter((_, j) => j !== i))} className="p-2 rounded-lg text-red-500 hover:bg-red-50"><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
      <button data-testid="cc-add" onClick={() => setVoci([...voci, ["", "Nuova voce"]])} className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-[#FC82ED]"><Plus size={14} /> Aggiungi voce</button>
      <button data-testid="cc-salva" onClick={save} disabled={saving} className="w-full mt-4 py-2.5 rounded-xl bg-[#111111] text-white font-semibold text-sm disabled:opacity-50">{saving ? "Salvo…" : "Salva checklist"}</button>
    </div>
  );
}
